import type { ReactNode } from 'react'

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info'

type BadgeProps = {
  children: ReactNode
  tone?: BadgeTone
  className?: string
  title?: string
}

/** Tone classes — timber status tokens (logic nghĩa trạng thái ở caller). */
export const BADGE_TONE_CLASS: Record<BadgeTone, string> = {
  neutral: 'bg-slate-100 text-[#515f74] border border-slate-200',
  success:
    'bg-[var(--color-success-soft)] text-[var(--color-success)] border border-emerald-200',
  warning:
    'bg-[var(--color-warning-soft)] text-[var(--color-warning)] border border-amber-200',
  danger:
    'bg-[var(--color-danger-soft)] text-[var(--color-danger)] border border-red-200',
  info: 'bg-[var(--color-info-soft)] text-[var(--color-info)] border border-sky-200',
}

export const BADGE_DOT_CLASS: Record<BadgeTone, string> = {
  neutral: 'bg-slate-400',
  success: 'bg-[var(--color-success)]',
  warning: 'bg-[var(--color-warning)]',
  danger: 'bg-[var(--color-danger)]',
  info: 'bg-[var(--color-info)]',
}

export function Badge({ children, tone = 'neutral', className = '', title }: BadgeProps) {
  return (
    <span
      title={title}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-[var(--radius-sm)] px-2 py-0.5 text-xs font-medium ${BADGE_TONE_CLASS[tone]} ${className}`}
    >
      {children}
    </span>
  )
}
